module.exports = __webpack_public_path__ + "static/img/CZ.cfe8be3b.svg";